module.exports = __webpack_public_path__ + "img/programming_or_design_sheet_button.f761eb3d.png";